import React from 'react'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import { Toggle } from '../icons'

export default class PuiMomentUtils extends AdapterMoment {
  constructor(opts?: any) {
    super(opts)

    const parentFormat = this.format

    // @ts-ignore
    this.format = (date, formatKey) => {
      const result = parentFormat(date, formatKey)

      if (formatKey === 'monthAndYear') {
        const [month, year] = result.split(' ')
        return (
          <>
            <span
              style={{
                color: '#3C3838',
                fontWeight: 400,
                width: 100,
                marginLeft: 20,
                marginTop: -2,
                display: 'inline-flex',
                alignItems: 'center',
                alignSelf: 'flex-start',
                justifyContent: 'center',
              }}
            >
              {month}
              <Toggle
                style={{
                  color: '#9F9B9B',
                  pointerEvents: 'none',
                  marginRight: '10px',
                }}
              />
            </span>
            <span
              style={{
                color: '#3C3838',
                fontWeight: 400,
                width: 82,
                marginTop: -2,
                display: 'inline-flex',
                alignItems: 'center',
                alignSelf: 'flex-start',
                justifyContent: 'center',
              }}
            >
              {year}
              <Toggle
                style={{
                  color: '#9F9B9B',
                  pointerEvents: 'none',
                }}
              />
            </span>
          </>
        )
      }

      return result
    }
  }
}
